import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BasicTooltip, ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, Chip, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import RippleEffect from 'src/components/general/RippleEffect';
import { track, events } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import useStyles from '../styles';
import { useTranslation } from 'react-i18next';
import { StatusCell } from '../StatusCell';
import { getIntervalBetweenDateAndNow, dateToFormat } from 'src/utils/date';
export const ResidentCell = observer(_ref => {
  var _store$fse$finalState, _params$row2, _params$row3, _params$row4, _params$row5;
  let params = _ref.params,
    handleClick = _ref.handleClick,
    setMmodalTempData = _ref.setMmodalTempData;
  const classes = useStyles();
  // const navigate = useNavigate();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Residencies Page';
  const _params$row = params.row,
    isAutoPayEnabled = _params$row.isAutoPayEnabled,
    residencyId = _params$row.residencyId;
  const fseInfoForRow = residencyId && ((_store$fse$finalState = store.fse.finalStatementInfo) === null || _store$fse$finalState === void 0 ? void 0 : _store$fse$finalState.find(f => f.residencyId === residencyId));
  const finalStatement = fseInfoForRow ? _objectSpread(_objectSpread({}, params.row.finalStatement || {}), fseInfoForRow) : params.row.finalStatement;
  const interval = getIntervalBetweenDateAndNow(finalStatement === null || finalStatement === void 0 ? void 0 : finalStatement.moveOutDate);
  const status = finalStatement === null || finalStatement === void 0 ? void 0 : finalStatement.status;
  const isFSEId = store.account.featureFlagsStore.isFinalStatementEstimationEnabled && (finalStatement === null || finalStatement === void 0 ? void 0 : finalStatement.fseId);
  const handleFSEClick = event => {
    event.stopPropagation();
    event.preventDefault();
    store.fse.setFSEBillModalData({
      accountId: params.row.accountId,
      residentName: params.row.fullname,
      residencyId: params.row.residencyId,
      unitName: params.row.unitName
    });
    store.fse.setFSEBillGeneralModalIsOpen(true);
  };
  const getBill = () => /*#__PURE__*/React.createElement("b", {
    className: "fseLink",
    onClick: handleFSEClick
  }, "review final statement");
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.overflowCellWrapper, " ").concat(classes.cellLeftAlign)
  }, !params.row.accountId && !store.company.companyFeatureStore.disableEnrollResident && /*#__PURE__*/React.createElement(Button, {
    className: classes.lightTrigger,
    onClick: event => {
      event.preventDefault();
      event.stopPropagation();
      track(events.modalOpened('Enroll Resident'), {
        page
      });
      store.enrollResident.changeInUnitValue('unitId', params.row.unitId);
      setMmodalTempData({
        unitname: params.row.unitName,
        occupancy: params.row.occupancy,
        unitData: [params.row.unitData],
        rowData: params.row
      });
      store.residencies.showEnrollmentModal(true);
      setTimeout(() => {
        document.getElementById('DGEnrollmentModal').click();
      }, 0);
    },
    variant: "actionButtonInvert",
    'custom-attribute': '224-ResidentCell'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Enroll resident'))), params.row.accountId && /*#__PURE__*/React.createElement("div", {
    className: classes.residentLine
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      if (!params.row.isEnrolmentScheduled) handleClick({
        row: params
      });
    },
    'custom-attribute': '225-ResidentCell'
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: params.row.fullname,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " ").concat(classes.cellLeftAlign, " cellContent")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, params.row.fullname))))), /*#__PURE__*/React.createElement(StatusCell, {
    params: params
  }), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.chipsWrapper
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: !(params.row.email || params.row.newEmail) || !((_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.emailConfirmed) || !!params.row.portalAccessDateOnly ? undefined : isAutoPayEnabled ? t('general.auto_pay_on') : t('general.auto_pay_off'),
    type: !(params.row.email || params.row.newEmail) || !((_params$row4 = params.row) !== null && _params$row4 !== void 0 && _params$row4.emailConfirmed) || !!params.row.portalAccessDateOnly ? undefined : isAutoPayEnabled ? 'success-bold' : 'warning'
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "auto-pay"
    }),
    color: !(params.row.email || params.row.newEmail) || !((_params$row5 = params.row) !== null && _params$row5 !== void 0 && _params$row5.emailConfirmed) || !!params.row.portalAccessDateOnly ? undefined : isAutoPayEnabled ? 'success' : 'warning',
    variant: "portal"
  })), params.row.isEnrolmentScheduled && /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: t('Enrolment scheduled'),
    type: 'warning'
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "warning"
    }),
    color: 'warning',
    variant: "portal"
  })))), isFSEId && status === 'ReadyForReview' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.finallBillWrapper, " ").concat(interval > 2 ? classes.finallBillWrapperReady : '', " finallBill")
  }, interval > 2 && /*#__PURE__*/React.createElement("span", null, "Final statement of ", params.row.fullname, " is ready. Please ", getBill(), " and send it by", ' ', dateToFormat(finalStatement === null || finalStatement === void 0 ? void 0 : finalStatement.moveOutDate), "."), interval <= 2 && /*#__PURE__*/React.createElement("span", null, params.row.fullname, " is moving out tomorrow. Please ", getBill(), " and send it by tomorrow.")), isFSEId && status === 'Overdue' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.finallBillWrapper, " ").concat(classes.finallBillWrapperOverdue, " finallBill")
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    state: "error",
    type: "warning"
  }), params.row.fullname, " moved out and the final statement are overdue. Please ", getBill(), " and send it as soon as possible.")), isFSEId && status === 'ProcessingError' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.finallBillWrapper, " ").concat(classes.finallBillWrapperOverdue, " finallBill")
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    fontSize: "small",
    state: "error",
    type: "warning"
  }), "There is an issue with your statement. Please contact the support")), isFSEId && status === 'SentToResident' && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.finallBillWrapper, " ").concat(classes.finallBillWrapperReady, " finallBill")
  }, /*#__PURE__*/React.createElement("span", null, "Final statement sent to the resident.", ' ', /*#__PURE__*/React.createElement("b", {
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      window.open("/resident_acount?id=".concat(params.row.residencyId, "&accountId=").concat(params.row.accountId, "&propertyId=").concat(params.row.propertyId, "&tab=statements"), '_blank');
    },
    'custom-attribute': '226-ResidentCell'
  }, "Please preview the statement."))));
});